exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hesap-ekstresi-report-table[data-v-5b93b9e9]{width:100%;margin-top:4px}.hesap-ekstresi-report-table>*[data-v-5b93b9e9]{width:100%}", ""]);

// exports
